import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import axios from "axios";
import toast from "react-hot-toast";

const InvoiceList = () => {
  const navigate = useNavigate();

  const [invoiceList, setInvoiceList] = useState([]);

  const [loading, setLoading] = useState(false);

  const [searchInvoiceNo, setSearchInvoiceNo] = useState("");
  const [showImportModal, setShowImportModal] = useState(false);
  const [orderList, setOrderList] = useState([]);
  const [selectedOrderId, setSelectedOrderId] = useState("");
  const [importFile, setImportFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  // ================= FETCH INVOICES =================
  const fetchInvoices = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/invoices`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      console.log("Invoice List => ", response.data);

      // IMPORTANT
      setInvoiceList(response.data.content);
    } catch (error) {
      console.error("Fetch Invoice Error => ", error);

      toast.error("Failed To Fetch Invoices");
    } finally {
      setLoading(false);
    }
  };
  const fetchOrders = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/orders?page=0&size=100`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setOrderList(response.data.content);
    } catch (error) {
      toast.error("Failed To Fetch Orders");
    }
  };
  // ================= DELETE INVOICE =================
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this invoice?",
    );

    if (!confirmDelete) return;

    try {
      const token = localStorage.getItem("token");

      await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/invoices/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      toast.success("Invoice Deleted Successfully");

      fetchInvoices();
    } catch (error) {
      console.error("Delete Invoice Error => ", error);
      toast.error("Failed To Delete Invoice");
    }
  };

  // ================= USE EFFECT =================
  useEffect(() => {
    fetchInvoices();
    fetchOrders();
  }, []);

  // ================= SEARCH FILTER =================
  const filteredInvoices = invoiceList.filter((invoice) =>
    invoice?.invoiceNo?.toLowerCase().includes(searchInvoiceNo.toLowerCase()),
  );
const handleImportInvoice = async () => {

    if (!selectedOrderId) {
        return toast.error("Please Select Order Id");
    }

    if (!importFile) {
        return toast.error("Please Upload File");
    }

    try {

        setUploading(true);

        const token = localStorage.getItem("token");

        const formData = new FormData();
        formData.append("file", importFile);

        await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/invoices/import-invoice?orderId=${selectedOrderId}`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        toast.success("Invoice Imported Successfully");

        setShowImportModal(false);
        setSelectedOrderId("");
        setImportFile(null);

        fetchInvoices();

    } catch (error) {

        console.error(error);
        toast.error("Failed To Import Invoice");

    } finally {
        setUploading(false);
    }
};
  return (
    <Layout>
      <div className="backgound-main-content p-4">
        <div className="container-fluid">
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
            <h3 className="mb-0 fw-bold">Invoice List</h3>

            <div className="d-flex gap-2">
              <button
                className="btn btn-success"
                onClick={() => setShowImportModal(true)}
              >
                Import Invoice
              </button>

              <button
                className="btn btn-primary"
                onClick={() => navigate("/create-invoice")}
              >
                Create Invoice
              </button>
            </div>
          </div>

          {/* Search */}
          <div className="row mb-4">
            <div className="search-bar">
              <input
                type="text"
                className="form-control"
                placeholder="Search by Invoice No"
                value={searchInvoiceNo}
                onChange={(e) => setSearchInvoiceNo(e.target.value)}
              />

              <Icon
                icon="iconamoon:search"
                width="20"
                height="20"
                color="rgba(0, 175, 239, 1)"
              />
            </div>
          </div>

          {/* Table */}
          <div className="table-responsive">
            <table className="table table-bordered table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>Sr No</th>
                  <th>Invoice No</th>
                  <th>Order Id</th>
                  <th>Date</th>
                  <th>Total Amount</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="7" className="text-center">
                      Loading...
                    </td>
                  </tr>
                ) : filteredInvoices.length > 0 ? (
                  filteredInvoices.map((invoice, index) => (
                    <tr key={invoice.id}>
                      <td>{index + 1}</td>

                      <td>{invoice.invoiceNo}</td>

                      <td>{invoice.orderId}</td>

                      <td>{invoice.date}</td>

                      <td>₹ {invoice.total}</td>

                      <td>
                        <span
                          className={`badge ${
                            invoice.paymentStatus === "PAID"
                              ? "bg-success"
                              : "bg-warning text-dark"
                          }`}
                        >
                          {invoice.paymentStatus}
                        </span>
                      </td>

                      <td>
                        <div className="d-flex gap-2 flex-wrap">
                          {/* View */}
                          <Icon
                            icon="hugeicons:view"
                            style={{
                              color: "#00AFEF",
                              fontSize: "18px",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              navigate(`/view-invoice/${invoice.id}`, {
                                state: {
                                  invoice,
                                },
                              })
                            }
                          />

                          {/* Edit */}
                          <Icon
                            icon="mdi:edit"
                            style={{
                              color: "#00AFEF",
                              fontSize: "18px",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              navigate("/create-invoice", {
                                state: {
                                  invoiceId: invoice.id,
                                  isEdit: true,
                                },
                              })
                            }
                          />

                          {/* Delete
                                                    <Icon
                                                        icon="material-symbols:delete-outline"
                                                        width="20"
                                                        className="cursor-pointer"
                                                        style={{ color: '#DD0000' }}
                                                        onClick={() =>
                                                            handleDelete(
                                                                invoice.id
                                                            )
                                                        }
                                                    />
                                                     */}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No Invoice Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {showImportModal && (
    <div
        className="modal fade show d-block"
        tabIndex="-1"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
        <div className="modal-dialog">
            <div className="modal-content">

                <div className="modal-header">
                    <h5 className="modal-title">
                        Import Invoice
                    </h5>

                    <button
                        className="btn-close"
                        onClick={() => setShowImportModal(false)}
                    />
                </div>

                <div className="modal-body">

                    {/* Order Dropdown */}
                    <div className="mb-3">

                        <label className="form-label fw-bold">
                            Select Order Id
                        </label>

                        <select
                            className="form-select"
                            value={selectedOrderId}
                            onChange={(e) =>
                                setSelectedOrderId(e.target.value)
                            }
                        >
                            <option value="">
                                Select Order
                            </option>

                            {orderList.map((order) => (
                                <option
                                    key={order.orderId}
                                    value={order.orderId}
                                >
                                    {order.orderId}
                                </option>
                            ))}
                        </select>

                    </div>

                    {/* File Upload */}
                    <div>

                        <label className="form-label fw-bold">
                            Upload Invoice File
                        </label>

                        <input
                            type="file"
                            className="form-control"
                            accept=".xlsx,.xls"
                            onChange={(e) =>
                                setImportFile(e.target.files[0])
                            }
                        />

                    </div>

                </div>

                <div className="modal-footer">

                    <button
                        className="btn btn-secondary"
                        onClick={() => setShowImportModal(false)}
                    >
                        Cancel
                    </button>

                    <button
                        className="btn btn-success"
                        onClick={handleImportInvoice}
                        disabled={uploading}
                    >
                        {uploading
                            ? "Uploading..."
                            : "Upload"}
                    </button>

                </div>

            </div>
        </div>
    </div>
)}
    </Layout>
  );
};

export default InvoiceList;
